import React, { Component, Fragment} from 'react';
import { Empty, Spin, Tooltip } from 'antd';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import Swal from "sweetalert2";
import Paging from "../../../components/paging";
import { IMG_HOST } from "../../../helper/host";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import Tour from "reactour";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { pageNumber } from "../../../functions/functionGeneral";
import { clear_auth, set_auth } from "../../../reducers/Auth";
import RefreshIcon from '../../../assets/icons/refresh.svg';
import '../style.css'
import { isOdd } from "../../../helper/function";
import {Modal as ModalRs, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import FilterIcon from "../../../assets/icons/filter.svg";
import SaveIcon from "../../../assets/icons/save.svg";
import { PERMISSIONS } from "../../../helper/permissionHelper";
import { withPageAccess } from "../../common/ProtectedPage";
import {TourContext} from "../../guideComponent/guideTourProvicer";


export class List_cuti_karyawan extends Component {
    static contextType = TourContext;
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            jabatan: [],
            data: [],
            history: [],
            idDel: '',
            karyawan_id: '',
            filter_nama: "",
            filter_jabatan: "",
            filter_divisi: "",
            pageCount: 0,
            totalData: 0,
            perPage: 0,
            paging: 15,
            currentPage: 0,
            pagination:2,
            karyawan_slug : '',
            modalEdit: false,
            dataCuti: [],
            karyawan_max_cuti: '',
            max_cuti: ''
        }
        this.handleChange = this.handleChange.bind(this)
        this.handlePageClick = this.handlePageClick.bind(this)
        this.resetFilter = this.resetFilter.bind(this)
        this.handleFilter = this.handleFilter.bind(this)
    }

    disableBody = target => disableBodyScroll(target)
    enableBody = target => enableBodyScroll(target)

    handlePageClick(data) {
        let selected = data.selected; // zero based index
        this.setState({ currentPage: selected }, () => {
            this.loadData()
            this.props.history.push('/laporan-cuti/' + selected)
        });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            currentPage: 0,
            [name]: value
        })
    }

    handleFilter(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value,
            data: [],
            loading: true,
            currentPage: 0
        }, () =>
            this.loadData(),
            this.props.history.push('/laporan-cuti/0')
        )
    }

    resetFilter(event) {
        this.setState({
            filter_nama: '',
            filter_jabatan: '',
            filter_divisi: '',
            data: [],
            loading: true,
            currentPage: 0
        }, () =>
            this.loadData(),
            this.props.history.push('/laporan-cuti/0'))
    }

    handleOk = e => {
        this.setState({
            modalimport: false,
            modalAction: false
        });
    };

    handleCancel = e => {
        this.setState({
            modalEdit: false,
            dataCuti: [],
            cuti: ''
        });
    };

    loadData() {
        let form = {
            paginate: this.state.paging,
            page: this.state.currentPage + 1,
            filter_nama: this.state.filter_nama,
            filter_jabatan: this.state.filter_jabatan,
            filter_divisi: this.state.filter_divisi,
        }
        this.props.request("karyawan/get-cuti-karyawan", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        data: response.data.data,
                        totalData: response.data.total,
                        pageCount: response.data.last_page,
                        perPage: response.data.per_page,
                        loading: false
                    })
                }
            });
    }

    loadDetail() {
        let form = {
            id: this.state.karyawan_id
        }
        this.props.request("karyawan/detail-cuti-karyawan", form,  'POST')
            .then(response => {
                if(response.success){
                    this.setState({
                        dataCuti: response.data,
                        karyawan_max_cuti: response.data.karyawan_max_cuti,
                        cuti: response.data.cuti,
                        modalEdit: true
                    })
                }
            });
    }

    updateCutiKaryawan = ()=> {
        this.setState({
            prosesSimpan: false
        })

        let form = {
            id         : this.state.karyawan_id,
            max_cuti   : this.state.karyawan_max_cuti,
        }

        this.props.request("karyawan/edit-cuti-karyawan", form, 'POST')
            .then(response => {
                if (response.success) {
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        showConfirmButton: false,
                        icon: 'success',
                        timer: 800
                    })
                }else{
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
                this.setState({
                    prosesSimpan: false,
                    modalEdit: false,
                    dataCuti: [],
                    cuti: ''
                }, () => {this.loadData()})
            });
    }

    checkSlug(karyawan, type) {
        if(karyawan.karyawan_slug != null){
            if (type === "detail") {
                this.props.history.push('/karyawan/profil/detail/'+ karyawan.karyawan_slug)
            } else if (type === "edit") {
                this.props.history.push('/karyawan/edit-karyawan/'+ karyawan.karyawan_slug + "/" + this.state.currentPage)
            }
            return;
        }
        let form = {
            id_karyawan : karyawan.karyawan_id,
        };
        this.props.request("karyawan/generate-slug", form, 'POST')
            .then(response => {
                if (response.success) {
                    if (type === "detail") {
                        this.props.history.push('/karyawan/profil/detail/'+ response.karyawan_slug)
                    } else if (type === "edit") {
                        this.props.history.push('/karyawan/edit-karyawan/'+ response.karyawan_slug + "/" + this.state.currentPage)
                    }
                    this.setState({
                        loading: false,
                    })
                }
            });
    }

    componentDidMount() {
        this.loadData()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.loading === true && this.state.loading === false) {
            this.tourTimeout = setTimeout(() => {
                const tourSteps = [
                    {
                        selector: '.karyawan-filter-nama',
                        title: 'Cari Nama Karyawan',
                        content: 'Gunakan kolom pencarian ini untuk mencari data cuti berdasarkan nama karyawan. Tekan Enter untuk memulai pencarian.'
                    },
                    {
                        selector: '.button-search-jabatan',
                        title: 'Filter',
                        content: 'Klik tombol ini untuk menampilkan atau menyembunyikan filter tambahan seperti jabatan dan divisi.'
                    },
                ];

                if (this.state.filter) {
                    tourSteps.push(
                        {
                            selector: '.karyawan-filter-jabatan',
                            title: 'Filter Jabatan',
                            content: 'Gunakan filter ini untuk menampilkan data cuti karyawan berdasarkan jabatan tertentu.'
                        },
                        {
                            selector: 'select[name="filter_divisi"]',
                            title: 'Filter Divisi',
                            content: 'Gunakan filter ini untuk menampilkan data cuti karyawan berdasarkan divisi tertentu.'
                        },
                        {
                            selector: '.karyawan-filter-reset',
                            title: 'Reset Filter',
                            content: 'Klik tombol ini untuk mengembalikan seluruh filter ke pengaturan awal dan memuat ulang data.'
                        }
                    );
                }

                if (!this.state.loading && this.state.data.length === 0) {
                    tourSteps.push({
                        selector: '.table-responsive',
                        title: 'Daftar Laporan Cuti (Kosong)',
                        content: 'Belum ada data cuti yang tersedia. Gunakan pencarian atau ubah filter untuk melihat data.'
                    });
                } else {
                    tourSteps.push(
                        {
                            selector: '.table-responsive',
                            title: 'Daftar Laporan Cuti',
                            content: `Tabel ini menampilkan ${this.state.data.length} data karyawan beserta informasi maksimal cuti dan cuti yang telah terpakai.`
                        },
                        {
                            selector: '.fa-ellipsis-h',
                            title: 'Aksi',
                            content: 'Klik ikon titik tiga untuk membuka menu aksi, seperti mengedit data maksimal cuti karyawan.'
                        }
                    );
                }

                const { setSteps, setCurrent, setActive } = this.context;
                setSteps(tourSteps);
                setCurrent(0);
                setActive(true);
            }, 500);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.tourTimeout);
    }

    render() {
        let no = 0;
        const stylefoto = {
            height: '50px',
            width: '50px',
            objectFit: 'cover'
        }
        const steps = [
            {
                selector: '.laporan-cuti',
                content: 'Daftar Laporan Cuti anda dapat dilihat disini',
            },
            {
                selector: '.filter-karyawan',
                content: 'Anda dapat mem-Filter daftar Karyawan anda lewat sini',
            },
        ];
        return (
            <Fragment>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>Laporan Cuti Karyawan - Presensi</title>
                        <meta name="description" content="Detail Presensi" />
                    </Helmet>
                    <Tour steps={steps} isOpen={this.state.guide === true} onAfterOpen={this.disableBody} onBeforeClose={this.enableBody} onRequestClose={() => this.setState({ guide: false })} />
                    <div className="container-fluid list-karyawan">
                        <div className='row pt-4'>
                            <div className='col-md-12'>
                                <div className='row'>
                                    <div className='col-md-12' style={{
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        lineHeight: "16px",
                                        color: "#5D6F80"
                                    }}>Presensi Admin Panel</div>
                                </div>
                                <div className='row' style={{ marginBottom: "28px" }}>
                                    <div className='col-md-12' style={{
                                        fontSize: "24px",
                                        lineHeight: "36px",
                                        fontWeight: 700,
                                        color: "#143B5E"
                                    }}>Laporan Cuti</div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-header pt-4 pb-0 px-1" style={{ borderBottom: "0px" }}>
                                <div className="row justify-content-between mx-0">
                                    <div className="col-12 col-md-9 row mx-0">
                                        <div className="col-md-4 px-1 karyawan-filter">
                                            <input name="filter_nama"
                                                   className="form-control karyawan-filter-nama"
                                                   placeholder="&#xF002; Nama Karyawan..."
                                                   type="text"
                                                   value={this.state.filter_nama}
                                                   onChange={this.handleChange}
                                                   onKeyUp={(event) => {
                                                       event.preventDefault()
                                                       if (event.which == 13) {
                                                           this.setState({
                                                               page: 0,
                                                               paging: this.state.paging,
                                                               loading: true
                                                           }, () => {
                                                               this.loadData()
                                                           });
                                                       }
                                                   }} />
                                        </div>
                                        <div className='col-md-3 px-1 d-flex flex-nowrap karyawan-filter'>
                                            <button className='btn primary button-filter px-2 button-search-jabatan' style={{ width: "94px" }} align="center" onClick={() => this.setState({ filter: !this.state.filter })}>
                                                <img src={FilterIcon} />Filter
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className='row mx-0 mt-3'>
                                    {this.state.filter && (
                                        <div className="px-3 d-flex flex-nowrap karyawan-filter">
                                            <select name="filter_jabatan" value={this.state.filter_jabatan} className="form-control karyawan-filter-jabatan mr-1 ml-1" onChange={this.handleFilter}>
                                                <option value="">Pilih Jabatan</option>
                                                {this.props.jabatan.map((item, index) => {
                                                    return (
                                                        <option value={item.jabatan_id}>{item.jabatan_nama}</option>
                                                    )
                                                })}
                                            </select>
                                            <select name="filter_divisi" value={this.state.filter_divisi} className="form-control karyawan-filter-jabatan mr-1" onChange={this.handleFilter}>
                                                <option value="">Pilih Divisi</option>
                                                {this.props.divisi.map((item, index) => {
                                                    return (
                                                        <option value={item.divisi_id}>{item.divisi_name}</option>
                                                    )
                                                })}
                                            </select>
                                            <div>
                                                <button className="karyawan-filter-reset" onClick={this.resetFilter}>
                                                    <img src={RefreshIcon} alt=''/>
                                                </button>
                                            </div>
                                        </div>
                                            )}
                                </div>
                            </div>
                            <div className="card-body px-2 daftar-karyawan" style={{ paddingTop: "40px" }}>
                                <div className="row">
                                    <div className="col-md-12 px-4">
                                        <div className="table-responsive">
                                            {!this.state.loading && this.state.data.length === 0 ?
                                                <Empty description="Data Kosong"
                                                       image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg" />
                                                :
                                                (this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("R") >= 0) && (
                                                    <table className="table table-striped mb-5">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ border: "none" }} width="30">#</th>
                                                                <th style={{ border: "none" }} className="text-center">Foto</th>
                                                                <th style={{ border: "none" }} className="text-left">Nama Karyawan</th>
                                                                <th style={{ border: "none" }} className="text-left">Jabatan-Divisi</th>
                                                                <th style={{ border: "none" }} className="text-left">Maksimal Cuti</th>
                                                                <th style={{ border: "none" }} className="text-left">Cuti Terpakai</th>
                                                                <th style={{ border: "none" }} className="text-left"></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.loading &&
                                                                <tr>
                                                                    <td colSpan={10}>
                                                                        <Spin size="large" tip="Loading..." style={{
                                                                            width: '100%',
                                                                            margin: 'auto',
                                                                            marginBottom: '10px',
                                                                            marginTop: '10px'
                                                                        }} />
                                                                    </td>
                                                                </tr>
                                                            }
                                                            {this.state.data.map((item, index) => {
                                                                no += 1
                                                                return (
                                                                    <tr style={item.status_karyawan !== 'active' ? (isOdd(index) ? {backgroundColor: '#FFDED7'} : {backgroundColor: '#F9B5A6'}) : {}}>
                                                                        <small>
                                                                            <th style={{ border: "none" }} scope="row">{pageNumber(no, this.state.perPage, this.state.currentPage)}</th>
                                                                        </small>
                                                                        <td style={{ border: "none" }} align="center">{item.karyawan_foto !== null ? (
                                                                            <img style={stylefoto} alt=''
                                                                                 src={IMG_HOST + 'frontapp/karyawan/' + item.karyawan_foto} />
                                                                        ) : (
                                                                            <img style={stylefoto} alt=''
                                                                                 src={IMG_HOST + "user-profile.png"} />
                                                                        )}</td>
                                                                        <td style={{ border: "none" }} align="left">
                                                                            {item.status_karyawan !== 'active' && (
                                                                                <div>
                                                                                    <p className={'badges-danger'}>KARYAWAN BELUM AKTIF</p>
                                                                                </div>
                                                                            )}
                                                                            {item.karyawan_no_induk && (
                                                                                <div>
                                                                                    <p className={'badges-induk'}>NI: {item.karyawan_no_induk}</p>
                                                                                </div>
                                                                            )}
                                                                            <span style={{ fontWeight: 500, color: "#248CE7", fontSize: "14px" }}><a onClick={this.checkSlug.bind(this, item, 'detail')}>{item.karyawan_nama}</a></span>
                                                                            <br />
                                                                            <div>
                                                                                <p className={'text-muted fs-5'} style={{ fontSize: "12px", lineHeight: "24px", fontWeight: 400 }}>{item.karyawan_email}</p>
                                                                            </div>
                                                                            {item.karyawan_payroll_amount === 0 ?
                                                                                <a href={"/daftar-gaji-karyawan"}>
                                                                                    <div className={"badge badge-warning"}>Lengkapi Payroll</div>
                                                                                </a>
                                                                                : ""
                                                                            }
                                                                        </td>
                                                                        <td style={{ border: "none" }} align="left">
                                                                            <span style={{ fontWeight: 400, fontSize: "14px", lineHeight: "24px", color: "#143B5E" }}>{item.jabatan && item.jabatan.jabatan_nama ? item.jabatan.jabatan_nama : '-'}</span><br /><div><p className={'text-muted fs-5'} style={{ fontSize: "14px", fontWeight: 400, lineHeight: "24px" }}>{item.divisi && item.divisi.divisi_name ? item.divisi.divisi_name : '-'}</p></div>
                                                                        </td>
                                                                        <td style={{ border: "none" }} align="left">
                                                                            <p style={{ fontWeight: 400, fontSize: "14px", lineHeight: "24px", color: "#143B5E" }}>
                                                                                {item.karyawan_max_cuti ? item.karyawan_max_cuti : '0'}
                                                                            </p>
                                                                        </td>
                                                                        <td style={{ border: "none" }} align="left">
                                                                            <p style={{ fontWeight: 400, fontSize: "14px", lineHeight: "24px", color: "#143B5E" }}>
                                                                                {item.cuti ? item.cuti.length : '0'}
                                                                            </p>
                                                                        </td>
                                                                        <td style={{ border: "none" }} align="center">
                                                                            <Tooltip trigger={'click'} placement="bottom" color={'#fff'} title={
                                                                                <div className={'p-2'}>
                                                                                    <a
                                                                                        onClick={ () => {
                                                                                            this.setState({
                                                                                                modalEdit: true,
                                                                                                karyawan_id: item.karyawan_id
                                                                                            }, () => {
                                                                                                this.loadDetail(item.karyawan_id);
                                                                                            })
                                                                                        }}
                                                                                        style={{marginRight: "50px"}}
                                                                                        className={'text-dark'}
                                                                                    >
                                                                                        Edit
                                                                                    </a>
                                                                                </div>
                                                                            }>
                                                                                <a><i
                                                                                    className="fa fa-ellipsis-h" style={{
                                                                                    width: 35,
                                                                                    fontSize: 18,
                                                                                    padding: 11,
                                                                                    color: 'rgb(51 51 51)'
                                                                                }}
                                                                                ></i></a>
                                                                            </Tooltip>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                                <Paging
                                    className="float-right"
                                    handlePageClick={this.handlePageClick}
                                    pageCount={this.state.pageCount}
                                    currentPage={this.state.currentPage}
                                />
                                <div className='col font-14' style={{ padding: "auto", margin: "auto", fontWeight: 500, lineHeight: "24px" }}>
                                menampilkan {this.state.data.length === 0 || this.state.data.length === null ? "0" : this.state.data.length} dari {this.state.totalData} data.
                                </div>

                                <ModalRs size="lg" zIndex={999} isOpen={this.state.modalEdit} style={{ maxWidth: "1000px" }} >
                                    <ModalHeader toggle={this.handleCancel} className="pengumuman-modal-header">
                                        <div className='pengumuman-modal-header-font'>
                                            Edit Cuti Karyawan
                                        </div>
                                    </ModalHeader>
                                    <ModalBody className="pengumuman-modal-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <form className="needs-validation user-add" noValidate="">
                                                    <div className="row">
                                                        <div className="form-group col-md-5">
                                                            <label
                                                                style={{fontSize: "12px", color: "#143B5E"}}
                                                                className="mb-2 font-weight-bold"
                                                            >
                                                                Nama Karyawan
                                                            </label>
                                                            <div className="mt-2">
                                                                <b>{this.state.dataCuti ? this.state.dataCuti.karyawan_nama : ''}</b>
                                                            </div>
                                                        </div>
                                                        <div className="form-group col-md-3">
                                                            <label style={{fontSize: "12px", color: "#143B5E"}}
                                                                   className="mb-2 font-weight-bold">
                                                                Maksimal Cuti
                                                            </label>
                                                            <div>
                                                                <input type="number" name="karyawan_max_cuti"
                                                                       className="form-control col-xl-5 col-md-4"
                                                                       placeholder={0}
                                                                       defaultValue={this.state.dataCuti && this.state.dataCuti.karyawan_max_cuti}
                                                                       onChange={this.handleChange}/>
                                                            </div>
                                                        </div>
                                                        <div className="form-group col-md-3">
                                                            <label style={{fontSize: "12px", color: "#143B5E"}}
                                                                   className="mb-2 font-weight-bold">
                                                                Cuti Terpakai
                                                            </label>
                                                            <div>
                                                                <input type="number" name="karyawan_max_cuti"
                                                                       className="form-control col-xl-5 col-md-4"
                                                                       placeholder={0}
                                                                       disabled={true}
                                                                       defaultValue={this.state.cuti && this.state.cuti.length}
                                                                       onChange={this.handleChange}/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </ModalBody>
                                    <ModalFooter className="pengumuman-modal-footer">
                                        <button className="pengumuman-cancel-button" onClick={this.handleCancel}>Batal
                                        </button>
                                        <button className='pengumuman-save-button' onClick={this.updateCutiKaryawan}>
                                            <img alt='' src={SaveIcon}/> Simpan
                                        </button>
                                    </ModalFooter>
                                </ModalRs>
                            </div>
                        </div>
                    </div>
                </Fragment>

        );
    }
}

const mapStateToProps = state => ({
    user: state.Auth.user,
    api_token: state.Auth.api_token,
    jabatan: state.Filter._jabatan,
    divisi: state.Filter._divisi
});

const mapDispatchToProps = dispatch => ({
    clear_auth: () => dispatch(clear_auth()),
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps)(withPageAccess(List_cuti_karyawan, PERMISSIONS.LAPORAN_CUTI));
